<template>
  <v-row dense>
    <template v-for="(item, i) in sortedItems">
      <v-col :key="i" lg="2" md="4" sm="6">
        <v-hover v-slot="{ hover }" close-delay="200">
          <v-card
            height="100%"
            class="card-bottom-actions"
            :elevation="hover ? 8 : 2"
            :class="{ 'on-hover': hover }"
            @click.stop="view(item)"
          >
            <media-thumbnail
              v-if="item.media"
              :value="getThumbnail(item)"
              :height="75"
            ></media-thumbnail>
            <v-card-text>{{ item.name | truncate(100, '...') }}</v-card-text>
            <v-card-actions class="card-actions-bottom">
              {{ item.shortId }}
              <v-spacer></v-spacer>

              <v-badge
                v-if="item.media.length > 0"
                :content="item.media.length"
                overlap
                class="mr-2"
              >
                <v-icon class="ml-2" :title="$t('mediaItems')">
                  mdi-image-multiple-outline
                </v-icon>
              </v-badge>

              <message-badge :id="item.id" />
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import mediaThumbnail from '@/components/media/media-thumbnail'
import messageBadge from '@/messaging/components/message-badge'

export default {
  components: { mediaThumbnail, messageBadge },
  props: {
    items: { type: Array, required: true }
  },
  computed: {
    ...mapGetters('messaging', ['unreadMessagesByEntity']),
    sortedItems() {
      return _.sortBy(this.items, 'shortId')
    }
  },
  methods: {
    getUnreadMessageCount(id) {
      return this.unreadMessagesByEntity(id)?.length || 0
    },
    getThumbnail(item) {
      if (item.media && item.media.length > 0) {
        const images = _.filter(item.media, function(o) {
          return o.contentType.startsWith('image')
        })

        if (images.length > 0) {
          return _.sortBy(images, 'shortId')[0]
        }
      }

      return null
    },
    view(item) {
      this.$emit('view', item)
    }
  }
}
</script>
